"use strict";

exports.__esModule = true;
exports.PlaylistPayload = void 0;
var _Constant = require("../Utils/Constant");
/*
 * COPYRIGHT 2020-2022 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */
var PlaylistPayload = /*#__PURE__*/function () {
  function PlaylistPayload(data, interSegmentTimeout, raw) {
    this.sessionIdentifier = data.get(_Constant.Payload.IDENTIFIER);
    this.location = data.get(_Constant.Payload.LOCATION);
    this.scheme = data.get(_Constant.Payload.SCHEME);
    this.hostNode = data.get(_Constant.Payload.HOSTNODE);
    this.port = data.get(_Constant.Payload.PORT);
    this.queryString = data.get(_Constant.Payload.QS);
    this.analyticUrl = data.get(_Constant.Payload.ANALYTICURL);
    this.pauseUrl = data.get(_Constant.Payload.PAUSEURL);
    this.availabilityStartTime = data.get(_Constant.Payload.AVAILABILITYSTART) || null; // set to `null` for HLS
    this.raw = raw ? raw : "";
    this.interSegmentTimeout = interSegmentTimeout;
  }
  var _proto = PlaylistPayload.prototype;
  _proto.getAnalyticUrl = function getAnalyticUrl() {
    return this.analyticUrl;
  };
  _proto.getIntersegmentTimeout = function getIntersegmentTimeout() {
    return this.interSegmentTimeout;
  };
  _proto.getLocation = function getLocation() {
    return this.location;
  };
  _proto.getHostNode = function getHostNode() {
    return this.hostNode;
  };
  _proto.getScheme = function getScheme() {
    return this.scheme;
  };
  _proto.getPauseUrl = function getPauseUrl() {
    return this.pauseUrl;
  };
  _proto.getPort = function getPort() {
    return this.port;
  };
  _proto.getQueryString = function getQueryString() {
    return this.queryString;
  };
  _proto.getRaw = function getRaw() {
    return this.raw;
  };
  _proto.getSessionIdentifier = function getSessionIdentifier() {
    return this.sessionIdentifier;
  };
  _proto.getAvailabilityStartTime = function getAvailabilityStartTime() {
    return this.availabilityStartTime;
  };
  return PlaylistPayload;
}();
exports.PlaylistPayload = PlaylistPayload;